var COURSE_ROLE = {
    0: 'none',
    1: 'student',
    2: 'teacher',
    3: 'jury',
};
export var hasCourseRole = function (sign, role) { return COURSE_ROLE[role] === sign; };
export var isStudentHomeWork = function (p, id) {
    var _a, _b;
    return (((_b = (_a = p === null || p === void 0 ? void 0 : p.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; })) === null || _b === void 0 ? void 0 : _b.value) || '') === id;
};
//# sourceMappingURL=hasCourseRole.js.mapvar COURSE_ROLE = {
    0: 'none',
    1: 'student',
    2: 'teacher',
    3: 'jury',
};
export var hasCourseRole = function (sign, role) { return COURSE_ROLE[role] === sign; };
export var isStudentHomeWork = function (p, id) {
    var _a, _b;
    return (((_b = (_a = p === null || p === void 0 ? void 0 : p.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === 'student_id'; })) === null || _b === void 0 ? void 0 : _b.value) || '') === id;
};
//# sourceMappingURL=hasCourseRole.js.map